import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const updateShotclass = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.UPDATE_SHOTCLASS,
    data
  );
};

export default updateShotclass;
